import type { TermMonthItem } from '@makemydeal/dr-platform-types';
import { FlexBuyAvailableMonths } from '@makemydeal/dr-platform-types';
import type {
    FlexBuyPaymentGridDataItems,
    FlexBuyPaymentsSlice,
    FlexBuyPaymentState,
    UpdateFlexBuyPaymentGridDataPayload
} from '../types/flexBuyTypes';

export const getFlexBuyPayment = (state: FlexBuyPaymentsSlice): FlexBuyPaymentState => state.flexBuyPayments as FlexBuyPaymentState;

export const getCurrentFlexBuyPayments = (state: FlexBuyPaymentsSlice): FlexBuyPaymentState['currentFlexBuyPayment'] | null =>
    state.flexBuyPayments?.currentFlexBuyPayment ?? null;

export const getFlexBuyPaymentGridData = (state: FlexBuyPaymentsSlice): UpdateFlexBuyPaymentGridDataPayload | null =>
    state.flexBuyPayments?.flexBuyPaymentGridData ?? null;

export const getFlexBuyPaymentGridItems = (state: FlexBuyPaymentsSlice): FlexBuyPaymentGridDataItems[] | undefined => {
    const gridData = getFlexBuyPaymentGridData(state);
    return gridData?.map((col) => col?.items);
};
/**
 * US2041815: when the flex buy grid last priced. Absent until a response has landed in this session, or
 * until a stored value is restored on load.
 */
export const getFlexBuyPaymentGridPricedAt = (state: FlexBuyPaymentsSlice): number | undefined =>
    state.flexBuyPayments?.flexBuyPaymentGridPricedAt;

export const getFlexBuyPaymentGridToggle = (state: FlexBuyPaymentsSlice): boolean =>
    state.flexBuyPayments?.paymentFlexBuyGridToggle ?? false;

export const getFlexBuyPaymentGridPercents = (state: FlexBuyPaymentsSlice): number[] => {
    return state.flexBuyPayments?.flexBuyPercents || [];
};

export const getFlexBuyPaymentGridPercentsList = (state: FlexBuyPaymentsSlice) => {
    const flexBuyPercents = getFlexBuyPaymentGridPercents(state);
    return flexBuyPercents.map((val, key) => ({ key, val }));
};

export const getFlexBuyPaymentGridTerms = (state: FlexBuyPaymentsSlice): number[] => {
    return state.flexBuyPayments?.flexBuyTerms || [];
};

export const getFlexBuyPaymentGridTermsList = (state: FlexBuyPaymentsSlice): TermMonthItem[] => {
    const terms = getFlexBuyPaymentGridTerms(state);
    return terms.map((val, key) => ({ key, val }));
};

export const getFlexBuyPaymentGridCashDowns = (state: FlexBuyPaymentsSlice) => {
    return state.flexBuyPayments?.flexBuyDownPayments || [];
};

export const getFlexBuyPaymentGridCashDownsList = (state: FlexBuyPaymentsSlice) => {
    const cashDowns = getFlexBuyPaymentGridCashDowns(state);
    return cashDowns.map((val, key) => ({ key, val }));
};

export const getInitialFlexBuyTermMonthList = () => {
    const initialFlexBuyTermMonthList = [
        FlexBuyAvailableMonths.MONTH_75,
        FlexBuyAvailableMonths.MONTH_66,
        FlexBuyAvailableMonths.MONTH_66
    ];

    return initialFlexBuyTermMonthList;
};
